import { createFileRoute, redirect } from "@tanstack/react-router";

import { PeopleSettings } from "@/features/settings/PeopleSettings";

/** Admins only. The server enforces it on every change; this keeps the screen honest. */
export const Route = createFileRoute("/_app/settings/people")({
  beforeLoad: ({ context }) => {
    if (context.me.user.role !== "admin") throw redirect({ to: "/settings/notifications" });
  },
  component: PeopleSettings,
});
